import { AppConstants } from "../AppConstants";

const { Languages } = AppConstants.ImagePaths;

const ExperienceData = [
  {
    id: "3",
    name: "Thinkbiz Technologies Pvt. Ltd. - Ahmedabad, Gujarat, India",
    role: "Jr. Software Engineer",
    duration: "Jan 2025 - Present",
    detail:
      "Led the team and developed an Assessment Platform to make the hiring process easier for the company. Built key features like live monitoring and proctoring of candidates, link-based exams without user registration, exam registration, result export and analysis with graphs, and notifications through both platform and email. Responsible for developing the Chatbot module from scratch, including both frontend and backend, and designing the cloud architecture for the platform. Also responsible for developing a Microservice module from scratch, handling frontend, backend, and infrastructure setup for an existing company product.",
    skills: [
      Languages.TypeScript,
      Languages.React,
      Languages.Node,
      Languages.Express,
      Languages.PostgreSQL,
      Languages.AWS,
    ],
  },
  {
    id: "2",
    name: "Oasis Infobyte - South West Delhi, India",
    role: "Web Development and Designing Intern",
    duration: "May 2024 - June 2024",
    detail:
      "Developed server-side applications using Express.js, including implementing authentication with JWT and validation mechanisms using Express Validator. Designed and managed API endpoints to handle GET and POST requests efficiently. Created a file organizer application in Node.js, automating the classification of files based on their extensions. Worked on MySQL database management, writing medium to complex SQL queries to retrieve specific data from tables for business needs.",
    skills: [
      Languages.Node,
      Languages.Express,
      Languages.MySQL,
    ],
  },
  {
    id: "1",
    name: "Ubrain Studios Pvt. Ltd. - Gujarat, India",
    role: "Web Development Intern",
    duration: "May 2023 - June 2023",
    detail:
      "As a Frontend developer, I developed a dynamic and responsive web application for movies. Successfully Integrated the third-party TMDB API to include a wide range of popular and recent movies in the app. Crafted a user-friendly UI with a 'Favourite Movies' section and improved user engagement by combine search, sorting, and filtering features. Utilized the browser's local storage capabilities to efficiently store and manage user-selected favourite movies data.",
    skills: [
      Languages.React,
      Languages.MongoDB,
      Languages.Material,
      Languages.Git,
      Languages.Github,
    ],
  },
];

export default ExperienceData;
